import React from "react";
import PropTypes from "prop-types";
import LoadingSpinner from "../LoadingSpinner";
import { formatDateWithTime } from "../../utils/formatters";

/**
 * User profile section displaying account information.
 */
const ProfileSection = ({ user, loading }) => {
  return (
    <section className="settings-section">
      <h2 className="settings-section-title">Profile</h2>
      {loading ? (
        <LoadingSpinner size="small" text="Loading profile..." />
      ) : user ? (
        <div className="settings-card">
          <div className="profile-grid">
            <div className="profile-field">
              <label className="profile-label">Email</label>
              <span className="profile-value">{user.email}</span>
            </div>
            <div className="profile-field">
              <label className="profile-label">Role</label>
              <span className="profile-value profile-role">
                {user.role || "user"}
              </span>
            </div>
            <div className="profile-field">
              <label className="profile-label">Member since</label>
              <span className="profile-value">
                {formatDateWithTime(user.created_at)}
              </span>
            </div>
            <div className="profile-field">
              <label className="profile-label">Last login</label>
              <span className="profile-value">
                {formatDateWithTime(user.last_login)}
              </span>
            </div>
          </div>
        </div>
      ) : (
        <div className="settings-card">
          <p className="settings-empty">Unable to load profile information.</p>
        </div>
      )}
    </section>
  );
};

ProfileSection.propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string,
    role: PropTypes.string,
    created_at: PropTypes.string,
    last_login: PropTypes.string,
  }),
  loading: PropTypes.bool,
};

export default ProfileSection;
